// ----------------------------------------------------------------------

export const PATH_AUTH = {
	login: "/login",
	recoverPassword: "/recover-password",
	resetPassword: "/reset-password"
};

export const PATH_DASHBOARD = {
	overview: "/overview",
	admin: "/admin",
	app: {
		settings: "/app/settings",
		overview: "/overview",
		transactions: "/app/transactions",
		positions: "/app/positions",
		transfers: "/app/transfers"
	},
	organization: "/organization",
	profile: "/profile"
};

export const PATH_LINK = {
	connect_account: "/link/connect-account",
	demo: {
		root: "/link/demo",
		transactions: "/link/demo/transactions",
		positions: "/link/demo/positions"
	}
};
